import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import EditLayout from 'layouts/crud/EditLayout'
import EditFormActions from 'layouts/crud/EditFormActions'
import IntegerConverterField from 'support/fields/IntegerConverterField'
import FormCard from 'ui/cards/FormCard'
import Title from 'layouts/page/Title'

export default class Edit extends CrudPageContent {
  get resourceName () {
    return 'domains'
  }

  get layout () {
    return EditLayout
  }

  get actions () {
    return <EditFormActions />
  }

  get fields () {
    return (
      <FormCard header={<Title />}>
        <Fieldset cols={2}>
          <Fields.Input name='domain' label='Domæne' />
          <Fields.Input name='description' label='Beskrivelse' />
          <IntegerConverterField name='price' label='Pris' step={0.01} min={0.01} />
          <Fields.Select
            name='status'
            enum='domain_status'
            placeholder='Vælg status'
            label='Status'
          />
          <Fields.TextArea name='dr_publish_distribution_info' label='DrPublish Distribution' />
        </Fieldset>
      </FormCard>
    )
  }
}
